import React, { useEffect, useState } from 'react';
import { applyNow, getState, subscribe } from '../utils/appUpdate';

/**
 * Fallback for the silent update (utils/appUpdate.js): shown only when a new version has been
 * waiting for over an hour of visible use without a safe moment to swap. Most people never
 * see it — the swap happens when they come back to the app.
 */
export default function UpdateBar() {
  const [state, setState] = useState(getState);
  useEffect(() => subscribe(setState), []);
  if (!state.overdue && !(state.applying && state.available)) return null;
  return (
    <div className="update-bar" role="status">
      <span className="update-bar-text">
        {state.applying ? '更新しています…' : '新しいバージョンがあります'}
      </span>
      {!state.applying && (
        <button type="button" className="update-bar-btn" onClick={applyNow}>
          更新
        </button>
      )}
    </div>
  );
}
